import { inject, Injector } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import type { OnyxHttpErrorResponse } from '@onyx/angular';
import { OnyxToastService } from '@onyx/angular';
import { catchError, map, of } from 'rxjs';
import { VALIDATION_ERROR_CODES } from '../../../../../common/constants/common/validation-error-codes';
import { ValidationHelper } from '../../../../../common/helpers/validation.helper';
import type { BaseFormResolverData } from '../../bases.routes';
import { BasesRoute } from '../enums/bases-route';
import { BaseFormHelper } from '../helpers/base-form.helper';
import { BasesService } from '../services/bases.service';

export const editBaseResolver: ResolveFn<BaseFormResolverData> = (
  route: ActivatedRouteSnapshot,
) => {
  const baseService = inject(BasesService);
  const toastService = inject(OnyxToastService);
  const injector = inject(Injector);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;

  return baseService.getBase(uuid).pipe(
    map((dto) => ({
      form: BaseFormHelper.fromDto(dto),
      initial: BaseFormHelper.fromDto(dto),
    })),
    catchError((response: OnyxHttpErrorResponse) => {
      if (VALIDATION_ERROR_CODES.includes(response.status)) {
        toastService.showError({
          message: 'bases.toasts.baseNotFound',
          keepOnNavigation: true,
        });
        response.handled = true;
      } else {
        ValidationHelper.handleUnexpectedResponse(response, injector, {
          keepOnNavigation: true,
        });
      }

      const urlTree = router.parseUrl(BasesRoute.BASES_LIST);
      return of(new RedirectCommand(urlTree, { replaceUrl: true }));
    }),
  );
};
